import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tooltip-wrapper", { 'tw-relative': _ctx.useRelativePositioning }])
  }, [
    _createElementVNode("div", {
      ref: "tooltipTrigger",
      class: _normalizeClass(["tooltip-trigger", [_ctx.triggerClass ? _ctx.triggerClass : '']]),
      onMouseover: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleMouseOver && _ctx.handleMouseOver(...args)))
    }, [
      _renderSlot(_ctx.$slots, "trigger", {}, undefined, true)
    ], 34),
    (_ctx.$slots.content)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          ref: "tooltip",
          class: _normalizeClass(["tooltip", [
        'tw-bg-primary',
        'tw-text-primary-foreground',
        'tw-z-50',
        'tw-rounded-md',
        'tw-px-3',
        'tw-py-1.5',
        'tw-text-xs',
        _ctx.tooltipClasses ? _ctx.tooltipClasses : ''
      ]]),
          style: _normalizeStyle(_ctx.tooltipStyle)
        }, [
          _renderSlot(_ctx.$slots, "content", {}, undefined, true)
        ], 6))
      : _createCommentVNode("", true)
  ], 2))
}